// Shared color palette — now sourced entirely from the centralised brand tokens.
// No hex literals live here; every value references ./brandTokens so both apps
// share one configurable visual identity. `ColorsEnum.<key>` access is unchanged.
import { ramps, semantic, chartPalette } from './brandTokens';

export { hexToRGBA } from './brandTokens';

const { primary, accent, neutral } = ramps;

export const ColorsEnum = {
  // brand
  primary: primary[500],
  secondary: accent[500],
  royalBlue: primary[800],
  machoBlue: primary[500],
  lighterMachoBlue: primary[300],
  memeBlue: primary[300],

  // semantic
  success: semantic.success.main,
  green: semantic.success.main,
  seeAndBeGreen: semantic.success.dark,
  error: semantic.error.main,
  red: semantic.error.main,
  sunshine: semantic.warning.main,
  yellow: semantic.warning.main,

  // decorative violets → brand chart violet
  lavender: chartPalette[3],
  amethyst: chartPalette[3],

  // neutrals (warm cream → ink ramp)
  gunmetal: neutral[700],
  black: neutral[950],
  grey: neutral[400],
  warmgray1: neutral[600],
  warmgray2: neutral[500],
  warmgray3: neutral[400],
  coolgray1: neutral[600],
  coolgray2: neutral[500],
  coolgray3: neutral[400],
  coolgray4: neutral[300],
  coolgray5: neutral[100],
  coolgray6: neutral[100],
  coolgray7: neutral[25],
  lightGrey: neutral[50],
  white: neutral[0],
  offWhite: neutral[50],
  darkGrey: neutral[800],
  darkerGrey: neutral[950],
} as const;

// Preserve enum-style type usage (`x: ColorsEnum`) if any caller needs it.
export type ColorsEnum = (typeof ColorsEnum)[keyof typeof ColorsEnum];
